import { mergeFragments, TableFragment, CellMarkdown, Sheet, Spreadsheet } from "./excel-model";

function titlePage(tableName, reportprefs) {
  const date = new Date();
  const dateStr = `${date.getDay()}.${date.getMonth()}.${date.getFullYear()}`;
  return new Sheet("Титульный лист", new TableFragment([2, 7], {
    data: [
      ["Отчёт о проведённом статистическом анализе", ""],
      ["", ""],
      ["По данным:", tableName || "<источник данных без названия>"],
      ["", ""],
      ["Дата отчёта:", dateStr],
      ["", ""],
      [reportprefs.titlecomment, ""]
    ],
    markdown: [
      { type: "cell", coord: [0, 0], style: { font: { bold: true, sz: 36 } } },
      { type: "cell", coord: [1, 4], format: { type: "date" } },
    ],
    columnWidth: [
      { wpx: 400 },
      { wpx: 400 },
    ],
    rowHeight:  [
      { hpx: 50 },
      { hpx: 20 },
      { hpx: 20 },
      { hpx: 20 },
      { hpx: 20 },
      { hpx: 20 },
      { hpx: 20 },
    ],
  }));
}

function tablePage(table) {
  return new Sheet("Исходные данные", new TableFragment([table.headers.length, 1 + table.data.length], {
    data: [table.headers, ...table.data],
    markdown: [
      { type: "row", coord: 0, style: { font: { bold: true } } },
    ],
    columnWidth: undefined,
    rowHeight: undefined,
  }));
}

function methodFragment([methodName, methodResults], methodNames) {
  if (!methodNames[methodName]) return null;
  const header = new TableFragment([1, 1], {
    data: [[methodNames[methodName]]],
    markdown: [new CellMarkdown([0, 0], null, { font: { bold: true } })],
  });
  const properties = methodResults.filter((property) => property.text).map((property) => [property.text]);
  if (properties.length === 0) return null;
  const frag = mergeFragments([
    [header],
    [TableFragment.plainData(properties)],
  ]);
  return frag;
}

function propertiesPage({ method, results }) {
  const frags = Object.entries(method).map(methodFragment).filter(Boolean);
  return new Sheet("Результаты по методам", mergeFragments(frags.map((frag) => [frag])));
}

/**
 * Функция, которая создаёт отчёт при помощи CreateExcel
 * @param table - таблица с данными и метаданными
 * @param reportprefs - настройки отчёта
 * @param tableName - наименование таблицы
 * @param reportContent - остальные листы отчёта
 */
export default function makeReport(table, reportprefs, tableName, reportContent) {
  const spreadsheet = new Spreadsheet([
    titlePage(tableName, reportprefs),
    tablePage(table),
    ...reportContent.map(({ sheetName, sheet: { n, m, data, markdown, columnWidth, rowHeight } }) => new Sheet(sheetName, new TableFragment([n, m], { data, markdown, columnWidth, rowHeight }))),
  ]);
  spreadsheet.createExcel();
}
